import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const TeacherLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { path: '/teacher', icon: '🏠', label: '대시보드' },
    { path: '/teacher/tts', icon: '🎙️', label: 'TTS 관리' },
    { path: '/teacher/content', icon: '✏️', label: '콘텐츠 관리' },
    { path: '/teacher/interview', icon: '🎤', label: '면접 관리' },
    { path: '/teacher/analytics', icon: '📊', label: '학습 분석' },
  ];

  const isActive = (path) => {
    if (path === '/teacher') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* 상단 네비게이션 */}
      <nav className="bg-white shadow-lg border-b">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* 로고 */}
            <div
              onClick={() => navigate('/teacher')}
              className="flex items-center space-x-3 cursor-pointer"
            >
              <span className="text-2xl">🎓</span>
              <span className="text-gray-800 text-xl font-bold">
                NCS 교사용 패널
              </span>
            </div>

            {/* 우측 메뉴 */}
            <div className="flex items-center space-x-4">
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:bg-gray-100 px-4 py-2 rounded-lg transition-colors duration-200 inline-block"
              >
                👨‍🎓 학생용 페이지
              </a>


            </div>
          </div>
        </div>
      </nav>

      <div className="flex">
        {/* 사이드바 */}
        <aside className="w-64 bg-white shadow-lg min-h-screen relative">
          <div className="p-6 pb-32"> {/* 하단 여백 추가 */}
            <h2 className="text-lg font-semibold text-gray-800 mb-6">메뉴</h2>

            <nav className="space-y-2">
              {menuItems.map((item) => (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-all duration-200 ${
                    isActive(item.path)
                      ? 'bg-gradient-to-r from-blue-500 to-green-500 text-white shadow-md'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  <span className="text-xl">{item.icon}</span>
                  <span className="font-medium">{item.label}</span>
                </button>
              ))}
            </nav>
          </div>

          {/* 하단 정보 - absolute에서 sticky로 변경 */}
          <div className="absolute bottom-0 left-0 right-0 w-64 p-4 bg-white border-t border-gray-200">
            <div className="bg-gradient-to-r from-blue-50 to-green-50 p-3 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <span className="text-base">💡</span>
                <span className="text-sm font-semibold text-gray-800">도움말</span>
              </div>
              <p className="text-xs text-gray-600 leading-relaxed">
                각 메뉴에서 NCS 학습 콘텐츠를 효율적으로 관리할 수 있습니다.
              </p>
            </div>
          </div>
        </aside>

        {/* 메인 콘텐츠 */}
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default TeacherLayout;